import { render, staticRenderFns } from "./addSingleBrand.vue?vue&type=template&id=18030146&scoped=true&"
import script from "./addSingleBrand.vue?vue&type=script&lang=js&"
export * from "./addSingleBrand.vue?vue&type=script&lang=js&"
import style0 from "./addSingleBrand.vue?vue&type=style&index=0&id=18030146&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18030146",
  null
  
)

export default component.exports